export default __webpack_public_path__ + "static/media/download.70d1942f.svg";